import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'

export type ShortlistReportLine = {
  applicantId: number
  firstname: string
  lastname: string
  rank: number | null
  accepted: boolean | null
  comment: string | null
}

export type ShortlistReport = {
  id: number
  contactName: string | null
  submittedAt: string | null
  applicants: ShortlistReportLine[]
}

export const useShortlistReport = (shortlistId: number, enabled: boolean) =>
  useQuery<ShortlistReport>({
    queryKey: ['shortlists', shortlistId, 'report'],
    queryFn: ({ signal }) =>
      fetchApiWithToken<ShortlistReport>({
        url: `/v1/shortlists/${shortlistId}`,
        signal
      }),
    enabled
  })
